export default "__VITE_ASSET__DaicDeCw__"